import React from 'react';
import { FileError } from 'use-file-picker';
import { Alert, AlertType } from '../../Alert';
import { MimeTypeAsString } from '../../../utils/fileMimeTypes';
import { UnsupportedFileType } from '..';

interface PropTypes {
  allowedFormats?: MimeTypeAsString[];
  errors: FileError[];
  maxFileSizeMb: number;
  maxFiles: number;
}

function ErrorMessage(props: {
  allowedFormats?: MimeTypeAsString[];
  error: FileError;
  maxFileSizeMb: number;
  maxFiles: number;
}) {
  if (props.error.fileSizeToolarge) {
    return (
      <span>
        <b>File is too large!</b> The maximum allowed file size is{' '}
        {props.maxFileSizeMb}MB.
      </span>
    );
  } else if (props.error.maxLimitExceeded) {
    return (
      <span>
        <b>Too many files selected!</b> The maximum number of files is{' '}
        {props.maxFiles}.
      </span>
    );
  } else if (
    props.allowedFormats != null &&
    props.error.name === UnsupportedFileType
  ) {
    return (
      <span>
        <b>File not supported!</b> The upload is only available for{' '}
        {props.allowedFormats} files.
      </span>
    );
  }

  return null;
}

export function AttachmentInputErrorMessages(props: PropTypes) {
  if (props.errors?.length > 0) {
    return (
      <Alert type={AlertType.Danger} clearable>
        <ErrorMessage
          error={props.errors[0]}
          maxFileSizeMb={props.maxFileSizeMb}
          maxFiles={props.maxFiles}
          allowedFormats={props.allowedFormats}
        />
      </Alert>
    );
  }

  return null;
}
